import { Drawer } from '@base-ui/react/drawer'
import { styled } from 'styled-components'

// Base UI drawer transition contract: follow the finger via the swipe CSS
// vars (duration 0 while swiping), scale the release duration by swipe
// velocity. Easing matches vaul's drawer curve.
const EASING = 'cubic-bezier(0.32, 0.72, 0, 1)'

export const Backdrop = styled(Drawer.Backdrop)`
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(0, 0, 0, 0.5);
  opacity: calc(1 - var(--drawer-swipe-progress, 0));
  transition: opacity 450ms ${EASING};

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }

  &[data-swiping] {
    transition-duration: 0ms;
  }

  &[data-ending-style] {
    transition-duration: calc(var(--drawer-swipe-strength, 1) * 400ms);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Viewport = styled(Drawer.Viewport)`
  position: fixed;
  inset: 0;
  z-index: 1301;
`

export const Popup = styled(Drawer.Popup)<{ $tall?: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  max-height: 90dvh;
  ${({ $tall }) => $tall && 'height: 90dvh;'}
  background: ${({ theme }) => theme.colors.white};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  outline: none;
  padding-bottom: env(safe-area-inset-bottom);
  transform: translate3d(0, var(--drawer-swipe-movement-y, 0px), 0);
  transition: transform 450ms ${EASING};
  will-change: transform;

  /* Covers the gap revealed below when the drawer is swiped past its resting point. */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 48px;
    background: ${({ theme }) => theme.colors.white};
    pointer-events: none;
  }

  &[data-starting-style],
  &[data-ending-style] {
    transform: translate3d(0, calc(100% + 2px), 0);
  }

  &[data-swiping] {
    transition-duration: 0ms;
  }

  &[data-ending-style] {
    transition-duration: calc(var(--drawer-swipe-strength, 1) * 400ms);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Content = styled(Drawer.Content)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
`
